// extracted by mini-css-extract-plugin
module.exports = {"FrontMap":"FrontMap_FrontMap__pu9vl","Heading":"FrontMap_Heading__1G8lp"};